<template>
    <div>
        <Toolbar :tooltipMessage="$t('Hier können Sie Impressum lesen.')" :toolbarTitle="translatedTitle" />
        <v-card>
            <v-card-text class="ck ck-content" v-html="getImpressum" />
        </v-card>
    </div>
</template>

<script>
import Toolbar from '../../Components/Generic/Toolbar';
import { mapGetters } from 'vuex';

export default {
    name: 'impressum',
    components: {
        Toolbar
    },
    data: () => ({
        toolbarTitle: 'Impressum'
    }),
    methods: {},
    computed: {
        ...mapGetters('SystemSettings', ['getImpressum']),
        translatedTitle() {
            return this.$t(this.toolbarTitle);
        }
    }
};
</script>
